export default "__VITE_ASSET__DkdxfQLU__"